import { MouseEvent } from "react";
import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { PieceListContext, PieceCardAction } from "features/builder/pieceList";

type MenuItem = {
  labelKey: string;
  icon: string;
  action: PieceCardAction;
  danger?: boolean;
};

const MINE_ITEMS: MenuItem[] = [
  { labelKey: "MSG_BUILDER_MENU_HINT", icon: "edit_note", action: PieceCardAction.HINT },
  { labelKey: "MSG_BUILDER_MENU_COPY", icon: "cached", action: PieceCardAction.COPY },
  {
    labelKey: "MSG_BUILDER_MENU_TO_TRASH",
    icon: "delete",
    action: PieceCardAction.TO_TRASH,
    danger: true,
  },
];

const PUBLIC_ITEMS: MenuItem[] = [
  { labelKey: "MSG_BUILDER_MENU_LIKE", icon: "favorite", action: PieceCardAction.LIKE },
  { labelKey: "MSG_BUILDER_MENU_REACTION", icon: "mood", action: PieceCardAction.REACTION },
  { labelKey: "MSG_BUILDER_MENU_COPY", icon: "cached", action: PieceCardAction.COPY },
  {
    labelKey: "MSG_BUILDER_MENU_REPORT",
    icon: "flag",
    action: PieceCardAction.REPORT,
    danger: true,
  },
];

// カード右上「⋮」のポップオーバーメニュー（軽量・カード内 absolute 配置）
export const PiecePopoverMenu = ({
  context,
  onClose,
  onAction,
}: {
  context: PieceListContext;
  onClose: () => void;
  onAction: (action: PieceCardAction) => void;
}) => {
  const play = usePlaySound();
  const items = context === PieceListContext.PUBLIC ? PUBLIC_ITEMS : MINE_ITEMS;

  const handleBackdrop = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onClose();
  };

  const handleItem = (action: PieceCardAction) => (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    play();
    onAction(action);
  };

  return (
    <div onClick={handleBackdrop} className="absolute inset-0 z-[5] pointer-events-auto">
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex-col-el absolute top-10 right-2 w-40 bg-white rounded-xl overflow-hidden shadow-lg border-solid border-2 border-gray2-30"
      >
        {items.map((item) => (
          <button
            key={item.action}
            type="button"
            onClick={handleItem(item.action)}
            className="type-inherit-font flex-row-el items-center gap-2 w-full px-3 py-1 bg-white border-0 cursor-pointer hover:bg-beige-60"
          >
            <span
              className={`material-symbols-outlined type-sm ${
                item.danger ? "text-danger" : "text-textcolor-black"
              } ${item.icon === "favorite" ? "material-symbols-filled" : ""}`}
            >
              {item.icon}
            </span>
            <p
              className={`type-text type-sm whitespace-nowrap ${
                item.danger ? "text-danger" : "text-textcolor-black"
              }`}
            >
              {I18n.t(item.labelKey)}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};
